import AgoraRTM from "agora-rtm-sdk";
import EventEmitter from "events";
import { AGORA_APP_ID, appVersion } from "../../service/config";
import moment from "moment";
import store from "../../redux/store";
import * as service from "../../service";

// apps2logd -> livelog

import SlsTracker from "@aliyun-sls/web-track-browser";
// 阿里云日志文档
// https://help.aliyun.com/zh/sls/developer-reference/use-web-tracking-sdk-for-javascript-to-collect-browser-logs?spm=a2c4g.11186623.0.0.6894419cYNYmfF

// 函数里面放置函数无法被调用，自定义一个容器：SLS容器、设备ID、用户ID
let trackerInit = null;
let deviceidInit = null;
let userIdInit = null;
// 启动链接日志
export function initSLSFunc() {
  const opts = {
    host: "cn-shanghai.log.aliyuncs.com", // 所在地域的服务入口。例如cn-hangzhou.log.aliyuncs.com
    project: "apps2logd", // Project名称。
    logstore: "livelog", // Logstore名称。
    time: 10, // 发送日志的时间间隔，默认是10秒。
    count: 10, // 发送日志的数量大小，默认是10条。
    topic: "FU_live", // 自定义日志主题。:通话时调用
    source: "h5",
  };
  trackerInit = new SlsTracker(opts); // 创建SlsTracker对象
  console.log("%c /=/链接sls", "color:green", trackerInit);
  deviceidInit = "h5_" + localStorage.getItem("fu_device_no");
  userIdInit = JSON.parse(localStorage.getItem("profile"))?.userId;
  console.log("/=/ceshi:", deviceidInit, userIdInit);
}
// 在src/components/easemob/WebIM.js使用两次，src/pages/Live/One2one.js使用一次
export function writeLogs(code, parameters) {
  console.log("/=/开始上传");
  // 单条日志立即上传（time和count参数不生效）
  trackerInit.sendImmediate({
    code, // 2001 是收到的  2003 是发出的
    appver: appVersion,
    time: moment().format("YYYY-MM-DD HH:mm:ss"),
    // osver: "13",
    deviceid: deviceidInit,
    userId: userIdInit,
    parameters,
  });
}
// 发送cmd：客户端,type:invite--邀请,alert-接收到视频邀请后发送
const sendCMDMessageRTM = (msgRes, calleeDevId_is, toId) => {
  let ext = {
    action: msgRes.action === "invite" ? "alert" : "confirmRing",
    status: true, // confirmRing  必填
    calleeDevId: calleeDevId_is
      ? localStorage.getItem("calleeDevId")
      : "h5_" + localStorage.getItem("fu_device_no"),
    callerDevId: calleeDevId_is
      ? "h5_" + localStorage.getItem("fu_device_no")
      : localStorage.getItem("calleeDevId"),
    msgType: "rtcCallWithAgora",
    callId: msgRes.callId,
  };
  console.log("%c rtm ------------------ info:", "color:green");
  console.log("/=/发送cmd---rtm消息-----：", ext);
  // 发送点对点消息
  const peerMessage1 = JSON.stringify(ext);
  rtm
    .sendPeerMessage(peerMessage1, toId)
    .then(() => {
      console.log("/=/-----点对点消息发送成功");
    })
    .catch((err) => {
      console.error("/=/-------点对点消息发送失败", err);
      const newVal={
        ...ext,
        tag_h5:'发送文本消息失败---RTM'
      }
      writeLogs(2003, newVal); // 发送cmd消息
    });
  // 上报接口---不像cmd是阿里日志
  const obj = {
    roomId: ext.callId,
    noticeChannel: 2,
    action: ext.action,
  };
  service.reportChannelUrl(obj).then((data) => {
    console.log("/=/上报接口日志：", data);
  });
};
export class RTMClient extends EventEmitter {
  constructor() {
    super();
    this.channels = {};
    this._logined = false;
  }

  init(appId) {
    this.client = AgoraRTM.createInstance(appId);
    this.subscribeClientEvents();
  }

  // subscribe client events
  // MessageFromPeer----通话监听
  subscribeClientEvents() {
    const clientEvents = [
      "ConnectionStateChanged",
      "MessageFromPeer",
      "RemoteInvitationReceived",
    ];
    clientEvents.forEach((eventName) => {
      this.client.on(eventName, (...args) => {
        console.log("emit ", eventName, ...args);
        console.log("/=/--------收到的rtm:", args);
        // 第一个参数是类型和数据，第二个参数是对方id，第三个参数是时间
        if (args.length === 3 && args[0].messageType === "TEXT") {
          try {
            const obj = JSON.parse(args[0].text);
            console.log("/=/--------收到的rtm22:", obj);
            // 下面的判断逻辑和IM相同
            if (obj.action === "invite") {
              window.localStorage.setItem("calleeDevId_is", false); // 是否存储接听方设备号
              window.localStorage.setItem("calleeDevId", obj.callerDevId); // 设置接听方设备号，confirmCallee需要用
              sendCMDMessageRTM(obj, false, args[1]); // 发送alert消息
            } else if (obj.action === "alert") {
              console.log("/=/-----收到alert消息,发送CALL_CONFIRM_RING");
              window.localStorage.setItem("calleeDevId_is", true); // 是否存储接听方设备号
              window.localStorage.setItem("calleeDevId", obj.calleeDevId); // 设置接听方设备号，confirmCallee需要用
              sendCMDMessageRTM(obj, true, args[1]); // 发送alert消息
            } else if (obj.action === "confirmRing") {
              // 此处需要和IM保持格式一致，src/pages/FUBase.js
              const newVal = {
                from: "socialfu_" + args[1],
                ext: {
                  callId: obj.callId,
                },
              };
              console.log("/=/-----接收到确认消息，打开接听也");
              store.dispatch({
                type: "videoStatus",
                payload: newVal,
              });
            } else if (obj.action === "confirmCallee") {
              console.log("/=/-----接收到确认消息，接听方加入房间");
            } else if (obj.action === "cancelCall") {
              console.log("/=/11作为接听方，拨打方主动挂断");
              store.dispatch({
                type: "videoStatusCancel",
                payload: true,
              });
            } else if (obj.action === "answerCall") {
              if (obj.result === "refuse") {
                console.log("/=/11收到接听方拒接接听");
                store.dispatch({
                  type: "videoStatusCancel2",
                  payload: true,
                });
              } else if (obj.result === "accept") {
                console.log("/=/11收到接听方加入房间");

                store.dispatch({
                  type: "videoStatusJoin",
                  payload: true,
                });
              }
            }
            else if (obj.action === "sendMessage") {
              console.log("/=/来自对方通话时的文字消息");
              store.dispatch({
                type: "videoStatusText",
                payload: obj.data.message,
              });
            }
          } catch (err) {
            console.log("todo: error");
            console.error(err);
          }
        }

        // log event message
        this.emit(eventName, ...args);
      });
    });
  }

  // subscribe channel events
  subscribeChannelEvents(channelName) {
    const channelEvents = ["ChannelMessage", "MemberJoined", "MemberLeft"];
    channelEvents.forEach((eventName) => {
      this.channels[channelName].channel.on(eventName, (...args) => {
        console.log("emit ", eventName, args);
        this.emit(eventName, { channelName, args: args });
      });
    });
  }

  async login(accountName, token) {
    this.accountName = accountName;
    return this.client.login({ uid: this.accountName, token }).then((ret) => {
      this._logined = true;
      return ret;
    });
  }

  async logout() {
    this._logined = false;
    return this.client.logout();
  }

  async joinChannel(name) {
    console.log("joinChannel", name);
    const channel = this.client.createChannel(name);
    this.channels[name] = {
      channel,
      joined: false, // channel state
    };
    this.subscribeChannelEvents(name);
    return channel.join();
  }

  async leaveChannel(name) {
    console.log("leaveChannel", name);
    if (
      !this.channels[name] ||
      (this.channels[name] && !this.channels[name].joined)
    )
      return;
    return this.channels[name].channel.leave();
  }

  async sendChannelMessage(text, channelName) {
    if (!this.channels[channelName] || !this.channels[channelName].joined)
      return;
    return this.channels[channelName].channel.sendMessage({ text });
  }

  async sendPeerMessage(text, peerId) {
    console.log("sendPeerMessage", text, peerId);
    return this.client.sendMessageToPeer({ text }, peerId.toString());
  }

  async queryPeersOnlineStatus(memberId) {
    console.log("queryPeersOnlineStatus", memberId);
    // return this.client.queryPeersOnlineStatus([memberId]);
    try {
      const status = await this.client.queryPeersOnlineStatus([
        memberId.toString(),
      ]);
      console.log("用户在线状态:", status);
      return status[memberId];
    } catch (err) {
      console.error("查询在线状态失败", err);
      return false;
    }
  }

  //send image
  async uploadImage(blob, peerId) {
    const mediaMessage = await this.client.createMediaMessageByUploading(blob, {
      messageType: "IMAGE",
      fileName: "agora.jpg",
      description: "send image",
      thumbnail: blob,
      // width: 100,
      // height: 200,
      // thumbnailWidth: 50,
      // thumbnailHeight: 200,
    });
    return this.client.sendMessageToPeer(mediaMessage, peerId);
  }

  async sendChannelMediaMessage(blob, channelName) {
    console.log("sendChannelMessage", blob, channelName);
    if (!this.channels[channelName] || !this.channels[channelName].joined)
      return;
    const mediaMessage = await this.client.createMediaMessageByUploading(blob, {
      messageType: "IMAGE",
      fileName: "agora.jpg",
      description: "send image",
      thumbnail: blob,
      // width: 100,
      // height: 200,
      // thumbnailWidth: 50,
      // thumbnailHeight: 200,
    });
    return this.channels[channelName].channel.sendMessage(mediaMessage);
  }

  async cancelImage(message) {
    const controller = new AbortController();
    setTimeout(() => controller.abort(), 1000);
    await this.client.downloadMedia(message.mediaId, {
      cancelSignal: controller.signal,
      onOperationProgress: ({ currentSize, totalSize }) => {
        console.log(currentSize, totalSize);
      },
    });
  }

  async sendLocalInvitation(param, callbacks) {
    //清除前一个localInvitation实例
    if (this.localInvitation) {
      this.localInvitation.removeAllListeners();
      this.localInvitation = null;
    }
    try {
      this.localInvitation = await this.client.createLocalInvitation(
        param.modelId
      );
      this.localInvitation.content = param.channelName;
      //console.log('[DEBUG]rtm localinvitation content:',this.localInvitation.content);
      this.localInvitation.on("LocalInvitationFailure", (r) => {
        console.log("======================rtm local invitation failed:", r);
      });
      this.localInvitation.on(
        "LocalInvitationRefused",
        callbacks["refused"] || (() => {})
      );
      this.localInvitation.on(
        "LocalInvitationAccepted",
        callbacks["accepted"] || (() => {})
      );
      this.localInvitation.on(
        "LocalInvitationReceivedByPeer",
        callbacks["received"] || (() => {})
      );
      this.localInvitation.on(
        "LocalInvitationFailure",
        callbacks["fail"] || (() => {})
      );

      await this.localInvitation.send();
    } catch (err) {
      console.log(".........rtm error caught");
      console.error(err);
    }
  }

  async cancelLocalInvitation() {
    try {
      if (this.localInvitation) {
        await this.localInvitation.cancel();
        this.localInvitation = null;
      }
    } catch (err) {
      console.error(err);
    }
  }
}

export const rtm = new RTMClient();

try {
  console.log("/=/执行rtm111");
  rtm.init(AGORA_APP_ID);
} catch (err) {
  console.error(err);
}
